module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('modal-window', {
    attrs: {
      "center": true,
      "grey": true,
      "close-button": true,
      "close-esc": false
    },
    on: {
      "close": function($event) {
        return _vm.$emit("close")
      }
    }
  }, [_c('div', {
    staticClass: "personal-data-consent"
  }, [_c('h2', {
    staticClass: "personal-data-consent__title"
  }, [_vm._v("Согласие с обработкой персональных данных")]), _c('p', {
    staticClass: "personal-data-consent__text"
  }, [_c('strong', [_vm._v("Внимание!")]), _vm._v("\nИзменились условия  " + _vm._s(_vm.$store.state.defaultLayout.dataSet.contacts.consent_pdp_file_url ? '' : 'согласия с обработкой персональных данных.')), (_vm.$store.state.defaultLayout.dataSet.contacts.consent_pdp_file_url) ? _c('ExtLink', {
    attrs: {
      "to": _vm.$store.state.defaultLayout.dataSet.contacts.consent_pdp_file_url,
      "external": "external",
      "target": "_blank"
    }
  }, [_vm._v("согласия с обработкой персональных данных.")]) : _vm._e(), _c('br'), _vm._v("Для дальнейшей работы на Платформе"), _c('br'), _vm._v("Вам необходимо подтвердить свое согласие.")], 1)]), _c('template', {
    slot: "footer"
  }, [_c('div', {
    staticClass: "personal-data-consent__actions"
  }, [_c('Button', {
    attrs: {
      "color": "default",
      "size": "medium",
      "rounded": true
    },
    on: {
      "click": function($event) {
        return _vm.$emit("confirm")
      }
    }
  }, [_vm._v("Даю согласие на обработку")])], 1)])], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2eed62bd","hasScoped":true,"preserveWhitespace":false}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/personalDataConsentModal/PersonalDataConsentModal.vue
// module id = 42666a33ceaaa276f582
// module chunks = 89